import GlobalModal from '@/utils/modal/Modal';
import { DeleteFilled } from '@ant-design/icons';
import { useState } from 'react';
import { useDeleteDeviceId } from './query/useDeviceIds';

export const DeleteModal = ({ id }) => {
  const [open, setOpen] = useState(false);
  const { mutate } = useDeleteDeviceId();
  const handleOk = async () => {
    mutate(id, {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };
  return (
    <>
      <div
        size="medium"
        className="text-danger tw-cursor-pointer"
        onClick={() => {
          setOpen(true);
        }}
      >
        <DeleteFilled />
      </div>
      <GlobalModal
        isVisible={open}
        onConfirm={() => handleOk()}
        onClose={() => setOpen(false)}
        type="delete"
      />
    </>
  );
};
